import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { updateRemittanceSettings } from "../api";

const useRemittanceSettingsForm = ({ refetch, closeModal, initialData }) => {
  const validation = Yup.object({
    advance_payment_percentage: Yup.string()
      .required("Advance payment percentage is required")
      .matches(/^\d+(\.\d+)?$/, "Must be a valid number"),
    rate_freeze_duration_hours: Yup.string()
      .required("Rate freeze duration is required")
      .matches(/^\d+(\.\d+)?$/, "Must be a valid number"),
    service_charge: Yup.string()
      .required("Service charge is required")
      .matches(/^\d+(\.\d+)?$/, "Must be a valid number")
  });

  const formik = useFormik({
    initialValues: {
      advance_payment_percentage:
        initialData?.advance_payment_percentage ?? "",
      rate_freeze_duration_hours:
        initialData?.rate_freeze_duration_hours ?? "",
      service_charge: initialData?.service_charge ?? "",
    },
    validationSchema: validation,
    enableReinitialize: true,
    onSubmit: (values) => {
      const obj = {
        advance_payment_percentage: Number(values.advance_payment_percentage),
        rate_freeze_duration_hours: Number(values.rate_freeze_duration_hours),
        service_charge: Number(values.service_charge),
      };

      updateRemittanceSettings(obj).then((res) => {
        if (res?.status === 200) {
          toast.success(
            res?.data?.message ?? "Remittance settings updated successfully"
          );
          refetch();
          closeModal();
        } else if (res?.data) {
          Object.keys(res.data).forEach((field) => {
            formik.setFieldError(field, res.data[field]?.[0]);
          });
        } else {
          toast.error(res?.message || "Failed to update settings");
        }
      });
    },
  });

  return { formik };
};

export default useRemittanceSettingsForm;
